
define('text!templates/modules/calendar/calendar/calendar-component/calendar-component.html',[],function () { return '<table class="calendar-table table" data-bind="classes:{\'list-table\':options_listDisplay}">\n    <thead></thead>\n    <tbody></tbody>\n</table>\n';});

